import React from "react";

import { ErrorGlobal } from "src/components";
import { useAuthStore } from "src/stores/auth-store";

export const ErrorFallback = () => {
  const logout = useAuthStore((state) => state.logout);

  return <ErrorGlobal onLogout={logout} />;
};
